const polyfill = {
  data: {},
  getItem(key) {
    return this.data[key];
  },
  setItem(key, value) {
    this.data[key] = value;
  },
  removeItem(key) {
    delete this.data[key];
  },
  clear() {
    this.data = {};
  }
};

var storage = polyfill;

try {
  localStorage.setItem('test', true);
  localStorage.removeItem('test');
  storage = localStorage;
} catch (e) {
  try {
    sessionStorage.setItem('test', true);
    sessionStorage.removeItem('test');
    storage = sessionStorage;
  } catch (e) {
    storage = polyfill;
  }
}

// Form Builder preferences (saved table views, the last export choice, the
// product tour and the Help tips switch) are stored per user id, hold nothing
// sensitive, and survive logging out.
const KEEP_ON_CLEAR = ['pp_forms_'];

const keptEntries = () => {
  const kept = [];
  try {
    const keys =
      typeof storage.key === 'function'
        ? Array.from({ length: storage.length }, (_, i) => storage.key(i))
        : Object.keys(storage.data);
    keys.forEach((key) => {
      if (key && KEEP_ON_CLEAR.some((prefix) => key.indexOf(prefix) === 0)) {
        kept.push([key, storage.getItem(key)]);
      }
    });
  } catch (e) {
    // Unreadable storage: nothing to keep.
  }
  return kept;
};

export default {
  get(key, defaultValue) {
    try {
      return JSON.parse(storage.getItem(key)) || defaultValue;
    } catch (e) {
      return storage.getItem(key) || defaultValue;
    }
  },
  removeItem(key) {
    storage.removeItem(key);
  },
  set(key, value) {
    return storage.setItem(
      key,
      typeof value === 'object' ? JSON.stringify(value) : value
    );
  },
  clear() {
    let cartId = storage.getItem('cartId') || '';
    let authLink = storage.getItem('auth-link') || '';
    let viewedHome = storage.getItem('viewed-home') || '';
    const kept = keptEntries();

    storage.clear();

    storage.setItem('cartId', cartId);
    storage.setItem('viewed-home', viewedHome);
    storage.setItem('auth-link', authLink);
    kept.forEach(([key, value]) => storage.setItem(key, value));
  },
  clearUser() {
    storage.setItem('user', '');
    storage.setItem('token', '');
  }
};
